import { PlanPurchaseExperienceSummaryLineProps } from './PlanPurchaseExperienceSummaryLine'
import { ReactNode } from 'react'
import { Typography } from '@dtx-company/design-system/src'

interface PlanPurchaseExperienceSummaryLineValueProps {
  appearance: PlanPurchaseExperienceSummaryLineProps['appearance']
  children?: ReactNode
  color?: string
}

export function PlanPurchaseExperienceSummaryLineValue(
  props: PlanPurchaseExperienceSummaryLineValueProps
): JSX.Element {
  const textColor =
    props.color || (props.appearance === 'primary' ? 'primary.main' : 'text.secondary')
  return (
    <Typography
      variant={props.appearance === 'primary' ? 'subtitleSmall' : 'bodyMedium'}
      color={textColor}
      fontWeight={props.appearance === 'primary' ? 'bold' : 'normal'}
    >
      {props.children}
    </Typography>
  )
}
